/**
 * The CRA production build keeps console.log, so debug output (response
 * bodies, request config) reached every visitor's console. In production make
 * console.log/debug no-ops; warn and error stay.
 */
export const silenceDebugLogs = (env = process.env.NODE_ENV, target = console) => {
  if (env !== "production") return;
  const noop = () => {};
  target.log = noop;
  target.debug = noop;
};
